import { PreOrder } from '../components/PreOrder';
import { useShippingPreOrderService } from '../services/useShippingPreOrderService';

export const ShippingPreOrderContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = useShippingPreOrderService();

  return <PreOrder {...service} />;
};
